import { CSSObject } from '@chakra-ui/react';

export const FlexSideLinkWrapper: CSSObject = {
  lineHeight: '4',
};
